import { cleanupPopupMenu, closePopupMenu } from "../lib/popup-menu";
import { useCallback, useRef } from "react";

export function usePopupMenuRef(): (
  element: HTMLDetailsElement | null,
) => void {
  const current = useRef<HTMLDetailsElement | null>(null);
  return useCallback((element: HTMLDetailsElement | null) => {
    if (current.current !== null && current.current !== element)
      cleanupPopupMenu(current.current);
    current.current = element;
  }, []);
}

export function PresetOption({
  label,
  available,
  initialTabStop,
  disabledReason,
  reasonId,
  onSelect,
}: {
  label: string;
  available: boolean;
  initialTabStop: boolean;
  disabledReason: string | undefined;
  reasonId: string;
  onSelect: () => void;
}) {
  return (
    <div className="preset-menu-option" role="none">
      <button
        type="button"
        role="menuitem"
        tabIndex={initialTabStop ? 0 : -1}
        onClick={(event) => {
          if (!available) return;
          closePopupMenu(event.currentTarget);
          onSelect();
        }}
        aria-disabled={!available || undefined}
        aria-describedby={disabledReason ? reasonId : undefined}
      >
        {label}
      </button>
      {disabledReason && (
        <span id={reasonId} className="preset-unavailable">
          {disabledReason}
        </span>
      )}
    </div>
  );
}
